import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_STOCK_OPNAMES = "SET_STOCK_OPNAMES";
export const SET_STOCK_OPNAMES_LOADING = "SET_STOCK_OPNAMES_LOADING";
export const SET_STOCK_OPNAMES_ERROR = "SET_STOCK_OPNAMES_ERROR";

const setError = (dispatch, error) => {
  dispatch({
    type: SET_STOCK_OPNAMES_ERROR,
    error: error?.response?.data?.message || error?.message || "Terjadi kesalahan pada data stock opname.",
  });
};

export const fetchStockOpnames = (limit = 100, page = 1, search = "", status = "") => async (dispatch) => {
  dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: true });

  try {
    const response = await authorizedAxios.get("/stock-opnames", {
      params: { limit, page, search, status: status || undefined },
    });
    dispatch({ type: SET_STOCK_OPNAMES, data: response?.data?.data });

    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: false });
  }
};

export const addStockOpname = (data) => async (dispatch) => {
  dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: true });

  try {
    await showToast(authorizedAxios.post("/stock-opnames", data), {
      loading: "Menyimpan stock opname...",
      success: "Stock opname berhasil ditambahkan!",
      error: (error) => error?.response?.data?.message || "Gagal menyimpan stock opname!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: false });
  }
};

export const updateStockOpname = (id, data) => async (dispatch) => {
  dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: true });

  try {
    await showToast(authorizedAxios.put(`/stock-opnames/${id}`, data), {
      loading: "Mengupdate stock opname...",
      success: "Stock opname berhasil diupdate!",
      error: (error) => error?.response?.data?.message || "Gagal mengupdate stock opname!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: false });
  }
};

export const processStockOpname = (id) => async (dispatch) => {
  dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: true });

  try {
    await showToast(authorizedAxios.put(`/stock-opnames/process/${id}`), {
      loading: "Memproses penyesuaian stok...",
      success: "Stock opname berhasil diproses!",
      error: (error) => error?.response?.data?.message || "Gagal memproses stock opname!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: false });
  }
};

export const deleteStockOpname = (id) => async (dispatch) => {
  dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: true });

  try {
    await showToast(authorizedAxios.delete(`/stock-opnames/${id}`), {
      loading: "Menghapus stock opname...",
      success: "Stock opname berhasil dihapus!",
      error: (error) => error?.response?.data?.message || "Gagal menghapus stock opname!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STOCK_OPNAMES_LOADING, status: false });
  }
};
